__turbopack_context__.v({
  "quantity": "cart-quantity-control-module__zcNtjq__quantity",
  "selectCell": "cart-quantity-control-module__zcNtjq__selectCell",
  "selectSpinner": "cart-quantity-control-module__zcNtjq__selectSpinner",
  "selectedValue": "cart-quantity-control-module__zcNtjq__selectedValue",
});
